import { createReducer, on } from '@ngrx/store';
import { createEntitySlice, withEntityReducer, withListReducer } from '@aston/foundation';

import * as featureActions from './actions';
import { initialState, ISubsidiaryDetailState } from './state';


// declare our fully typed reducer
export const SubsidiaryDetailStoreReducer = createReducer<ISubsidiaryDetailState>(
	initialState,

	...withListReducer<ISubsidiaryDetailState>('usersList', featureActions.usersListActions),
	...withEntityReducer<ISubsidiaryDetailState>('currentSubsidiary', featureActions.CurrentSubsidiaryActions),
	...withEntityReducer<ISubsidiaryDetailState>('subsidiaryForm', featureActions.UpdateSubsidiaryActions),
	...withEntityReducer<ISubsidiaryDetailState>('availableRolesForCurrentSubsidiary', featureActions.LoadAvailableRolesForCurrentSubsidiaryActions),

	...withEntityReducer<ISubsidiaryDetailState>('transientUserStatus', featureActions.UpdateTransientUserStatusActions),
	...withEntityReducer<ISubsidiaryDetailState>('transientSubsidiaryRole', featureActions.UpdateTransientSubsidiaryRoleActions),
	...withEntityReducer<ISubsidiaryDetailState>('subsidiaryUserDelegations', featureActions.subsidiaryUserDelegationActions),
	...withEntityReducer<ISubsidiaryDetailState>('subsidiaryUserDelegationsForm', featureActions.subsidiaryUserDelegationFormActions),
	...withEntityReducer<ISubsidiaryDetailState>('subsidiaryUserInactivityForm', featureActions.subsidiaryUserInactivityFormActions),

	on(featureActions.ToggleIsEditingSubsidiary, state => ({
		...state,
		subsidiaryFormIsEditing: !state.subsidiaryFormIsEditing
	})),

	on(featureActions.LoadSubsidiaryRequest, (state, action) => ({
		...state,
		currentSubsidiaryId: action.id,
		subsidiaryFormIsEditing: false,
		subsidiaryForm: {
			...state.subsidiaryForm,
			error: null
		}
	})),

	on(featureActions.UpdateSubsidiarySuccess, state => ({
		...state,
		subsidiaryFormIsEditing: false
	})),

	on(featureActions.SetActiveModal, (state, action) => ({
		...state,
		activeModal: action.modal,
		subsidiaryUserDelegations: action.modal ? state.subsidiaryUserDelegations : createEntitySlice(),
		subsidiaryUserDelegationsForm: action.modal ? state.subsidiaryUserDelegationsForm : createEntitySlice()
	})),

	on(featureActions.UpdateTransientUserStatusRequest, state => ({
		...state,
		subsidiaryUserDelegations: createEntitySlice(),
		subsidiaryUserDelegationsForm: createEntitySlice()
	})),

	on(featureActions.OpenUserInactivityForm, state => ({
		...state,
		subsidiaryUserInactivityForm: {
			...state.subsidiaryUserInactivityForm,
			error: false,
		}
	}))
);
